<template>
    <div style="position: relative;z-index: 1;padding-top:10px;">
        <div style="margin: 5px;overflow-y: auto;min-height:500px;">
            <Divider style="margin-top: 0px;" />
            <div class="treeGlobal" style="position: relative;">
                <Tree :data="localDataRes" :render="renderContent" @on-select-change="onLocalSelectChange" empty-text=""></Tree>
                <Spin fix v-if="spinShow3" style="width: 180px;padding-left: 100px;">
                    <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                    <div v-if="loadTreeSucess">数据加载中...</div>
                    <div v-else>加载失败</div>
                </Spin>
            </div>
        </div>
    </div>
</template>
<script>
// import datatree from '../../static/api/asidetree.json'
import city from './common/aside/city.vue'
//data
import { mapActions, mapGetters } from 'vuex'
import ConstJson from "../api/common/constjson.js"
import store from '../store/'
import eventBus from "../components/common/event_bus.js"
let constJ = new ConstJson()
let parents = null;
export default {
    name: 'AsideMenu',
    data() {
        return {
            tabVulue: "2",
            datares: [],
            localDataRes: [],
            lastTreeSelectedData: [],
            lastLocalTreeSelectData: [],
            cityValue: [],
            isRenderLocalTree: false,
            spinShow3: true,
            loadTreeSucess: true,
            // label: (h) => {
            //   return h('div', [
            //     h('span', '地方版'),
            //     h('Badge', {
            //       props: {
            //         text : "未开放",
            //         color:"blue",
            //       }
            //     })
            //   ])
            // }
        }
    },
    created() {

    },
    mounted() {
        console.log("aside_menu-----mounted..")
        //切换到首页时更新版本currentVersion
        // if (this.tabVulue === "1") {
        //     store.state.user.initData.currentVersion = '1'
        // }
        // var routeName = this.$route.name;
        // console.log("routeName===>" + routeName)

        //切换默认地方版后的逻辑
        setTimeout(() => {
            this.switchCard("2")
            //this.$emit("content-load-complete")
        }, 500)


        //切换默认地方版前的逻辑
        // if (routeName === "search") {
        //     this.tabVulue = "1"
        //     this.load_leftree()
        //     this.init()
        // } else if (routeName === "localindex") {
        //     this.switchCard("2")
        //     // this.tabVulue = "2"
        //     // this.load_local_lefttree()
        // }

        eventBus.$on('user-refresh-newlist', () => {
            console.log('user-refresh-newlist=====>')
            //刷新列表后默认到全国版
            // this.load_leftree()
            // this.init()
            //刷新列表后默认到地方版
            this.switchCard("2")
        })

        // if (this.tabVulue==="1") {
        //    this.init()
        // }
        // this.init()//默认打开第一个树节点
    },
    beforeDestroy() {
        eventBus.$off('user-refresh-newlist')
    },

    methods: {
        treefilter(data) {
            //特定适用对象=000001
            let rlt = false
            if (data.value === this.$Tools.getFileClass().SPECIFIC_APPLICABLE_OBJECTS) {
                rlt = true
            }
            if (data.value === this.$Tools.getFileClass().TAX_INCENTIVES) {
                rlt = true
            }
            if (data.value === this.$Tools.getFileClass().TAX_CONVENTION) {
                rlt = true
            }
            return rlt
        },
        renderContent(h, { root, node, data }) {
            return h('span', {
                style: {
                    display: 'inline-block',
                    width: '100%',
                    color: this.treefilter(data) ? '#FE7D37' : '#515A6E',
                    fontWeight: this.treefilter(data) ? '900' : 'normal',
                }
            }, [
                h('span', [
                    h('span', data.title)
                ]),
                h('span', {
                    style: {
                        display: 'inline-block',
                    }
                }, [
                    h('Icon', {
                        props: {
                            type: 'md-star',
                            size:'14'
                        },
                        style: {
                            display:this.treefilter(data) ? 'inline-block' : 'none',
                        }
                    }),

                ])
            ]);
        },
        init() {
            //console.log('init....')
            this.cleanSelected()
            let map = []
            var p = { key: 0, value: "", id: "0", node: null }
            map.push(p)
            this.$emit("OnSelectChange", map, "1");
        },
        //递归tree
        getParentNode(treeNodes, nodepid) {
            if (!treeNodes || !treeNodes.length) return;
            for (var i = 0; i < treeNodes.length; i++) {
                if (parents && parents.value == nodepid || nodepid == "pptr") {
                    return;
                }
                var childs = treeNodes[i].children;
                if (treeNodes[i].value == nodepid) {
                    parents = treeNodes[i];
                    return;
                }
                if (childs && childs.length > 0) {
                    this.getParentNode(childs, nodepid);
                }
            }

        },
        cleanSelected() {
            console.log("clear...")
            let data = this.lastTreeSelectedData
            //console.log(data)
            if (data.length > 0) {
                data[0].selected = false
                this.OnSelectChange(data)
            }

        },
        onCityChanged(value) {
            // console.log('aside_menu------onCityChanged')
            // console.log(value)
            // this.cityValue = value
            // this.$emit("onCityChanged", value)
            // this.load_local_lefttree(value)

        },
        onLocalSelectChange(data) {
            if (data.length === 0) { return }
            //设置city组件的classid
            this.lastLocalTreeSelectData = data
            parents = null;
            if (data[0] == undefined) {
                return;
            }

            if (data.length === 0) {
                return;
            }
            let map = [];
            //map.push({key:"home",value:"Home",id:"0",pid:"0"});
            var item = { key: data[0].nodeKey, value: data[0].title, id: data[0].value, node: data[0] };
            if (data[0].pv == "pptr") {
                map.push(item)
            } else {
                while (parents == null || parents.pv != "pptr") //根据用户选择的节点递归父级节点-显示路径
                {
                    if (parents == null) {
                        this.getParentNode(this.localDataRes, data[0].pv);
                        var p = { key: parents.nodeKey, value: parents.title, id: parents.value, node: data[0] }
                        map.push(p)
                    } else {
                        this.getParentNode(this.localDataRes, parents.pv);
                        var p = { key: parents.nodeKey, value: parents.title, id: parents.value, node: data[0] }
                        map.unshift(p)
                    }
                }
                map.push(item)
            }
            this.$emit("OnLocalSelectChange", map, "2", this.cityValue);
        },
        OnSelectChange(data) {
            this.lastTreeSelectedData = data
            parents = null;
            if (data[0] == undefined) {
                return;
            }

            if (data.length === 0) {
                return;
            }
            let map = [];
            //map.push({key:"home",value:"Home",id:"0",pid:"0"});
            var item = { key: data[0].nodeKey, value: data[0].title, id: data[0].value, node: data[0] };
            if (data[0].pv == "pptr") {
                // console.log("pptr")
                map.push(item)
            } else {
                //var parent= { key: p_node.nodeKey, value: p_node.title, id: p_node.id};
                while (parents == null || parents.pv != "pptr") //根据用户选择的节点递归父级节点-显示路径
                {
                    if (parents == null) {
                        //console.log("parents=null:" + data[0].value)
                        this.getParentNode(this.datares, data[0].pv);
                        var p = { key: parents.nodeKey, value: parents.title, id: parents.value, node: data[0] }
                        map.push(p)
                    } else {
                        //console.log("parents!null:" + parents.value)
                        this.getParentNode(this.datares, parents.pv);
                        var p = { key: parents.nodeKey, value: parents.title, id: parents.value, node: data[0] }
                        map.unshift(p)
                    }


                    // console.log(p)
                }
                map.push(item)
            }
            store.commit("setSelectNode", item) //set node data to vuex
            //console.log(store.state.user.selectNode);
            console.log('setSelectNode=====================>')
            console.log(map)

            this.$emit("OnSelectChange", map, "1");

            //判断树节点访问权限
            // if (this.checkTreePermission(map)) {
            //     this.$emit("OnSelectChange", map, "1");
            // }


            //data[0].selected = !data[0].selected
        },
        //税收优惠和税收条约需要验证权限
        checkTreePermission(map) {
            //税收优惠根节点id=000002
            //税收条约根节点id=000007
            //权限，税收优惠检索=000004
            //权限，条约检索=000005

            let reductioncode = this.$Tools.getPermission().CODE_FUNC_SEARCH_REDUCTION
            let treatycode = this.$Tools.getPermission().CODE_FUNC_SEARCH_TREATY
            if (map && map.length > 0) {
                let root = map[0]
                if (root.id === "000002") {
                    //未登录先登录，已登录判断是否有税收优惠权限
                    if (this.checkPermission(reductioncode)) {
                        return true
                    } else {
                        console.log('没有税收优惠权限')
                        this.$Message.warning('没有税收优惠权限')
                        return false
                    }
                } else if (root.id === "000007") {
                    //未登录先登录，已登录判断是否有税收条约权限
                    if (this.checkPermission(treatycode)) {
                        return true
                    } else {
                        console.log('没有税收条约权限')
                        this.$Message.warning('没有税收条约权限')
                        return false
                    }
                } else {
                    return true
                }
            }

        },
        //权限控制
        checkPermission(code) {
            //"000014" // 普通下载
            let rsp = false
            let checkcode = code
            let permission = this.sta.permission
            if (permission && permission.length > 0) {
                let index = permission.findIndex(p => p.f === checkcode)
                console.log('checkcode.index:' + index)
                if (index >= 0) {
                    rsp = true
                }
            }
            return rsp
        },

        switch2(name) {
            this.isRenderCity = false
            this.$nextTick(() => {
                this.isRenderCity = true
            })
            let map = []
            var p = { key: 0, value: "", id: "0", node: null }
            map.push(p)
            this.$emit('refreshMap', map)
            this.handleSetCurrentVersion(name)
        },

        switchCard(name) {
            console.log("switchCard:" + name)
            this.$emit("OnCardSwitch", name);
            this.tabVulue = name
            if (name === "2") {
                this.isRenderCity = false
                this.$nextTick(() => {
                    this.isRenderCity = true
                })
                let map = []
                var p = { key: 0, value: "", id: "0", node: null }
                map.push(p)
                this.$emit('refreshMap', map)
                this.load_local_lefttree()
            } else if (name === "1") {
                this.isRenderCity = false
                //console.log("gotoRoute...")
                //this.gotoRoute("search")
            }


            //console.log("version:"+store.state.user.initData.currentVersion)
            //constJ.login()
            //this.handle_tmpLogin()
            //this.load_leftree()
        },
        gotoRoute(rName) {
            this.$router.push({
                name: rName,
                query: {
                    classid: 0,
                }
            })
        },
        //数据访问
        //临时登录
        handle_tmpLogin() {
            //console.log(this.sta.isLogin)
            this.handleTempLogin()
                .then(res => {
                    console.log("临时用户登录成功")
                    //this.handle_lefttree()
                    //console.log(this.sta.isLogin)
                })
                .catch(err => {
                    console.log(err)
                })
        },
        load_leftree() {
            // console.log("loading tree...")
            // console.log(this.sta.isLogin)
            // console.log(this.sta.initData)
            // console.log(this.sta.initData.leftTree)
            if (this.sta.isLogin) {
                this.datares = this.sta.initData.leftTree;
                //this.handle_lefttree()
            }
            // else {
            //   this.handle_tmpLogin()
            // }
        },
        load_local_lefttree(value) {
            if (this.sta.isLogin) {
                console.log("loading local tree...",value)
                this.handle_Local_lefttree(value)
                //this.localDataRes=this.datares
            }
        },
        load_empty() {
            this.datares = []
        },
        handle_Local_lefttree(value) {
            var that = this
            constJ.ReqGetLeftTree(value).then(res => {
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        this.loadTreeSucess = true
                        that.spinShow3 = false
                        console.log("init local tree success======>")
                        console.log(res)
                        this.localDataRes = res.datas
                    } else {
                        that.spinShow3 = true

                        //reject(res.rltdesc)
                    }
                } else {
                    that.spinShow3 = true
                    //reject(res.rtndesc)
                }
            }).catch(err => {
                //reject(err)
                console.log(err)
            })
        },
        ...mapActions([
            'handleTempLogin', 'handleSetCurrentVersion' //vuex中定义的actions
        ]),
    },
    computed: {
        ...mapGetters(['sta', 'isLogin', 'ltree', 'provinceCityData'])
    },
    components: {
        'CityComponent': city
    },
    watch: {
        // isLogin:function(){
        //   //console.log(this.isLogin)
        //   if(this.isLogin==true)
        //   {
        //     //this.load_leftree()
        //   }
        // },
        $route(to, from) {
            if (to.name === "search" && from.name === "localindex") {
                this.tabVulue = "1"
                if (this.tabVulue === "1") {
                    store.state.user.initData.currentVersion = '1'
                }
                var routeName = this.$route.name;
                if (routeName === "search") {
                    this.tabVulue = "1"
                    this.load_leftree()
                    this.init()
                }
            }
        },
        ltree: function() {
            //console.log("tree...")
            if (this.isLogin == true) {
                this.load_leftree()
            }
        },
    }
}
</script>
<style>
.treeGlobal {
    width: 80px;
}

/*.treeGlobal > .ivu-tree  {
  font-size: 20px !important;
}

.treeGlobal > .ivu-tree ul {
  font-size: 20px !important;
}*/

/*.treeGlobal > .ivu-tree ul li {
  font-size: 12px !important;
}
*/
.treeGlobal>.ivu-tree ul li {
    /*  font-size: 12px !important;
  display: block;
  width:140px;
  white-space:normal;*/
    /*  word-break : break-all; 
  word-wrap: break-word;*/
}

/* 菜单换行 start*/
.treeGlobal>.ivu-tree ul>li {
    display: block;
    width: 104px;
    font-size: 12px;

}

.ivu-tree-title {
    white-space: normal;
}

/* 菜单换行 end*/
</style>
<style scoped>
/*spin style*/
.demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
}

.demo-spin-icon-load-falure {}

@keyframes ani-demo-spin {
    from {
        transform: rotate(0deg);
    }

    50% {
        transform: rotate(180deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.demo-spin-col {
    height: 100px;
    position: relative;
    border: 1px solid #eee;
}

.ivu-tabs-nav-scroll {
    display: none;
}


</style>